export default __webpack_public_path__ + "static/media/ponttrencat.8ba755f5.jpeg";